var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 98,
    viewBox: "0 0 292 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -67.8693,
    y: -67.8693,
    width: 427.739,
    height: 233.739
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(33.93px)",
      clipPath: "url(#bgblur_0_5953_7108_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 67.8693,
    y: 98,
    width: 98,
    height: 292,
    rx: 30,
    transform: "rotate(-90 0 98)",
    fill: "#D9D9D9",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.6864 74L57.0224 61.7445L38.0145 25H25.3359L19 37.2482H31.6852L50.6864 74ZM63.365 49.4963L69.7075 37.2482L63.365 25H50.693L44.3571 37.2482H57.0289L63.365 49.4963Z",
    fill: "#03D9AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0289 37.2482L63.365 25H50.693L44.3571 37.2482H57.0289Z",
    fill: "#03D9AF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6852 37.2482L38.0145 25H25.3359L19 37.2482H31.6852Z",
    fill: "#03D9AF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.417 67.5456C102.781 67.5456 101.565 66.8736 100.728 65.5296L85.934 41.8416L92.1331 38.1876L104.151 57.1716C104.227 57.2976 104.303 57.3816 104.417 57.3816C104.493 57.3816 104.607 57.3396 104.683 57.1716L116.662 38.1876L122.862 41.8416L108.068 65.5296C107.231 66.8736 106.014 67.5456 104.417 67.5456Z",
    fill: "#F7F7F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M152.073 67.63L148.688 62.422H129.407L126.022 67.63L119.823 63.976L135.377 40.288C136.252 38.944 137.469 38.272 139.067 38.272C140.587 38.272 141.805 38.944 142.717 40.288L158.272 63.976L152.073 67.63ZM133.628 55.996H144.505L139.332 48.058C139.219 47.932 139.143 47.848 139.067 47.848C138.99 47.848 138.876 47.932 138.8 48.058L133.628 55.996Z",
    fill: "#F7F7F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M190.549 67.4623C189.218 67.4623 188.001 66.9583 186.898 65.9083L169.67 49.7803C169.518 49.6963 169.404 49.6543 169.328 49.6963C169.252 49.7803 169.214 49.8643 169.214 50.0323V67.0003H162.102V44.1943C162.102 42.0943 162.444 40.6243 163.129 39.7843C163.814 38.9443 164.764 38.5243 165.943 38.5243C167.236 38.5243 168.453 39.0703 169.594 40.0783L186.822 56.1643C186.936 56.2903 187.05 56.3323 187.126 56.2483C187.203 56.2063 187.279 56.0803 187.279 55.9123V38.9023H194.39V61.7923C194.39 63.9343 194.01 65.4043 193.325 66.2443C192.641 67.0843 191.69 67.4623 190.549 67.4623Z",
    fill: "#F7F7F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M231.215 67.63L227.83 62.422H208.549L205.164 67.63L198.965 63.976L214.52 40.288C215.394 38.944 216.611 38.272 218.208 38.272C219.73 38.272 220.947 38.944 221.859 40.288L237.414 63.976L231.215 67.63ZM212.77 55.996H223.647L218.475 48.058C218.361 47.932 218.284 47.848 218.208 47.848C218.132 47.848 218.018 47.932 217.942 48.058L212.77 55.996Z",
    fill: "#F7F7F7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M273 64.06L266.915 68.26L259.157 58.684H248.47V67.042H241.244V45.244C241.244 43.228 241.701 41.632 242.689 40.54C243.678 39.448 245.086 38.902 246.949 38.902H262.58C266.23 38.902 268.854 39.7 270.452 41.296C272.049 42.892 272.886 45.412 272.886 48.772C272.886 53.728 271.061 56.794 267.448 58.054L273 64.06ZM248.47 47.092V51.502H263.036C263.949 51.502 264.633 51.376 265.052 51.082C265.432 50.788 265.66 50.116 265.66 49.108C265.66 48.1 265.432 47.47 265.014 47.134C264.595 46.84 263.949 46.672 263.036 46.672H248.85C248.584 46.672 248.47 46.84 248.47 47.092Z",
    fill: "#F7F7F7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_5953_7108_clip_path",
    transform: "translate(67.8693 67.8693)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 98,
    width: 98,
    height: 292,
    rx: 30,
    transform: "rotate(-90 0 98)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup9);
export default __webpack_public_path__ + "static/media/Group (9).e887cfa0b572f30f8d16de24e67c72c6.svg";
export { ForwardRef as ReactComponent };